export default {
    url: '/material/:guid?viewOnly',
    template: `
        <loader-icon ng-if="!vm.loaded"></loader-icon>
        <courses-authoring-tool-view
            ng-if="vm.loaded"
            company="vm.company"
            view-only="vm.viewOnly"
            material="vm.materialSubmission.material"
            material-submission="vm.materialSubmission"
        />
    `,
    controller (
        WindowConfirmService,
        MaterialSubmissionResource,
        $stateParams,
        $location,
        CompanyService,
        lodash,
        toastr,
        $translate
    ) {
        this.loaded = false;

        // the learner portal opens this state with "undefined" when creating the submission failed
        if (!$stateParams.guid || $stateParams.guid === 'undefined') {
            toastr.error($translate.instant('general.Something went wrong'));
            return;
        }

        /**
         * The chapters of every language share one material. The learner sees the chapters that
         * are visible in the language of the submission, with the name and the content of that language.
         * A chapter without translations comes from a material not migrated to the shared structure yet,
         * its own name and content are already in the language of that material.
         */
        const getLearnerChapters = (chapters, language) => {
            const learnerChapters = [];

            lodash.forEach(chapters, (chapter) => {
                if (!chapter.chapterI18ns || !chapter.chapterI18ns.length) {
                    learnerChapters.push(chapter);
                    return;
                }

                const translation = lodash.find(chapter.chapterI18ns, (chapterI18n) =>
                    (chapterI18n.language || '').toUpperCase() === language
                );
                if (!translation || !translation.isVisible) {
                    return;
                }

                chapter.name = translation.name;
                chapter.content = translation.content;

                if (chapter.section && chapter.section.sectionI18ns) {
                    const sectionTranslation = lodash.find(chapter.section.sectionI18ns, (sectionI18n) =>
                        (sectionI18n.language || '').toUpperCase() === language
                    );
                    if (sectionTranslation) {
                        chapter.section.name = sectionTranslation.name;
                    }
                }

                learnerChapters.push(chapter);
            });

            return learnerChapters;
        };

        MaterialSubmissionResource.get({
            guid: $stateParams.guid,
            expand: [
                'material.chapters',
                'material.chapters.chapterI18ns',
                'material.chapters.section',
                'material.chapters.section.sectionI18ns',
                'occurrenceTraining.training.activeI18n',
                'user.company'
            ].join(','),
            fallbackLanguage: $stateParams.fallbackLanguage
        }).$promise.then((materialSubmission) => {
            // submissions created before the language was stored on them fall back to the language of the page
            const language = (
                materialSubmission.lang || $location.search().lang || materialSubmission.user.company.defaultLanguage || ''
            ).toUpperCase();

            materialSubmission.material.chapters = getLearnerChapters(materialSubmission.material.chapters, language);
            this.loaded = true;

            if (materialSubmission.user.company.skin) {
                CompanyService.loadSkin(materialSubmission.user.company.skin);
            }
            this.materialSubmission = materialSubmission;
            this.viewOnly = $stateParams.viewOnly;
            this.company = materialSubmission.user.company;
            // ask confirmation if user refresh
            WindowConfirmService.activate();
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/material/do/index.js